import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';


const Header = () => {

  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const currentPath = window.location.pathname;
  const headerClass = currentPath === "/" ? "main-header sticky-header sticky-header--normal" : "main-header main-header--five sticky-header sticky-header--normal";

  const [scrollDirection, setScrollDirection] = useState(null);
 
  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    }
  }, [scrollDirection]);


  const mobileNavOpen = (e) => {
      const mobNavWrap = document.querySelector('.mobile-nav__wrapper');
      const mobNavBody = document.querySelector('body');

      mobNavWrap.classList.add('expanded');
      mobNavBody.classList.add('locked');
  };


  const Header1 = () => 
    <div className="container-fluid">
        <div className="main-header__inner">
            <div className="main-header__logo">
                <Link to="/">
                    <img src="assets/images/logo-dark.png" alt="Growim" width="160" />
                    <img src="assets/images/logo-light.png" alt="Growim" width="160" />
                </Link>
            </div>
                <nav className="main-header__nav main-menu">
                    <ul className="main-menu__list">
                        <li><NavLink exact activeClassName="current" to="/">Home</NavLink></li>
                        <li><NavLink activeClassName="current" to="/about">About</NavLink></li>
                        <li><NavLink activeClassName="current" to="/why-choose-us">Why Choose Us</NavLink></li>
                        <li><NavLink activeClassName="current" to="/services">Services</NavLink></li>
                        <li><NavLink activeClassName="current" to="/portfolio">Portfolio</NavLink></li>
                        <li><NavLink activeClassName="current" to="/contact">Contact</NavLink></li>
                    </ul>
                </nav>    
            

            <div className="main-header__right">
                <div className="mobile-nav__btn mobile-nav__toggler" onClick={mobileNavOpen}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>                    
                <Link to="/contact" className="growim-btn growim-btn--white main-header__btn">
                    <span className="growim-btn__text">Start A Project</span>
                </Link>
            </div>
        </div>
    </div>;
    
    const Header2 = () => 
    <div className="container-fluid">
        <div className="main-header--five__inner">
            <div className="topbar">
                <ul className="list-unstyled topbar__info">
                    <li className="topbar__info__item">
                        <span className="topbar__info__icon"><i class="flaticon-phone"></i></span>
                        <Link to="tel:+918478861990">+91 84788 61990</Link>
                    </li>
                    <li className="topbar__info__item">
                        <span className="topbar__info__icon"><i class="flaticon-email"></i></span>
                        <Link to="mailto:contact@digitalkoushik.com">contact@digitalkoushik.com</Link>
                    </li>
                </ul>

                <div className="topbar__social">
                    <Link to="https://www.facebook.com/consultantdigitalkoushik" target="_blank"><i className="fab fa-facebook-f" aria-hidden="true"></i><span className="sr-only">Facebook</span></Link>
                    <Link to="https://www.linkedin.com/in/digitalkoushik/" target="_blank"><i className="fab fa-linkedin-in" aria-hidden="true"></i><span className="sr-only">Linkedin</span></Link>
                    </div>
            </div>

            <div className="main-header__inner">
                <div className="main-header__logo">
                    <Link className="<?php echo esc_url( home_url( '/' ) ); ?>">
                        <img src="assets/images/logo-dark.png" alt="Logo" width="160" />
                    </Link>
                </div>
                <nav class="main-header__nav main-menu">
                    <ul className="main-menu__list">
                        <li><NavLink exact activeClassName="current" to="/">Home</NavLink></li>
                        <li><NavLink activeClassName="current" to="/about">About</NavLink></li>
                        <li><NavLink activeClassName="current" to="/why-choose-us">Why Choose Us</NavLink></li>
                        <li><NavLink activeClassName="current" to="/services">Services</NavLink></li>
                        <li><NavLink activeClassName="current" to="/portfolio">Portfolio</NavLink></li>
                        <li><NavLink activeClassName="current" to="/contact">Contact</NavLink></li>
                    </ul>
                </nav>

                <div className="main-header__right">
                    <div className="mobile-nav__btn mobile-nav__toggler" onClick={mobileNavOpen}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>                             
                    <Link to="/contact" class="growim-btn main-header__btn"><span className="growim-btn__text">Work With Us</span></Link>
                </div>
            </div>
        </div>
    </div>;


  return (
    <header className={`${headerClass} ${scrollDirection === "down" ? "sticky-header--cloned active" : "up"}`}>
      {isHomePage ? <Header1 /> : <Header2 />}
    </header>
  );
}

export default Header